
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trading-competition-v3/referral",
      function () {
        return require("private-next-pages/trading-competition-v3/referral.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trading-competition-v3/referral"])
      });
    }
  